/**
 * The gap forces a separation between the left set of elements and the right set. It fills up the space and forces
 * them to the respective ends.
 *
 * Note: If this proves problematic in the long run, we could put wrappers around the left and right hand sets of
 * elements and then use Flexbox's "justify-content: space-between;" to get the same effect.
 */
export default function GapDirective() {
  return {
    restrict: 'E'
  };
}
